import {ApiBuilder} from './builder';
import {Endpoints} from '../endpoints';


export async function addToCart(product_id, product_quantity, vin = '') {
    return await (new ApiBuilder(Endpoints.EndPointAddToBasket))
        .post()
        .withBody({
            product_id,
            product_quantity,
            vin
        })
        .send();
}

export async function addToRequestBasket(product_id, product_quantity, vin = '') {
    return await (new ApiBuilder(Endpoints.EndPointAddToBasketRequest))
        .post()
        .withBody({
            product_id,
            product_quantity,
            vin
        })
        .send()
}

export async function getCartCount() {
    return await (new ApiBuilder(Endpoints.EndPointBasketItemCount))
        .get()
        .send();
}

export async function getRequestBasketCount() {
    return await (new ApiBuilder(Endpoints.EndPointBasketRequestItemCount))
        .get()
        .send();
}

export async function updateCartCount() {
    const response = await getCartCount();
    const dataCartItemCount = document.querySelectorAll('[data-cart-item-count]');
    if (dataCartItemCount && response.hasOwnProperty('count')){
        dataCartItemCount.forEach((cartItem) => {
            cartItem.innerHTML = response.count;
        })
    }

}

export async function updateRequestBasketCount() {
    const response = await getRequestBasketCount();
    const dataCartItemCount = document.querySelectorAll('[data-cart-request-item-count]');
    if (dataCartItemCount && response.hasOwnProperty('count')){
        dataCartItemCount.forEach((cartItem) => {
            cartItem.innerHTML = response.count;
        })
    }
}

